export const ServiceActionTypes = {
    SET_CURRENT_SERVICE_GROUP: "SET_CURRENT_SERVICE_GROUP",
    SET_CURRENT_SERVICE: "SET_CURRENT_SERVICE",
};
